import { Route } from '../Routing/types';
import {
  DietSettingsWeight,
  DietSettingsDietMode,
  DietSettingsGoalWeight,
  DietSettingsDietType,
  DietSettingsDietLevel,
  DietSettingsActivityLevel,
  DietSettingsSex,
  DietSettingsHeight,
  DietSettingsDateOfBirth,
  DietSettingsAllSummary,
} from '@front-activerse/modules';

const dummy_t = (translationKey: string) => translationKey;

const descendantRoutes: Route[] = [
  {
    path: '/diet-type',
    private: false,
    title: dummy_t('goalSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <DietSettingsDietType />,
  },
  {
    path: '/diet-level',
    private: false,
    title: dummy_t('goalSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <DietSettingsDietLevel />,
  },
  {
    path: '/weight',
    private: false,
    title: dummy_t('goalSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <DietSettingsWeight />,
  },
  {
    path: '/diet-mode',
    private: false,
    title: dummy_t('goalSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <DietSettingsDietMode />,
  },
  {
    path: '/goal-weight',
    private: false,
    title: dummy_t('goalSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <DietSettingsGoalWeight />,
  },
  {
    path: '/activity-level',
    private: false,
    title: dummy_t('goalSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <DietSettingsActivityLevel />,
  },
  {
    path: '/sex',
    private: false,
    title: dummy_t('userSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <DietSettingsSex />,
  },
  {
    path: '/birth-date',
    private: false,
    title: dummy_t('userSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <DietSettingsDateOfBirth />,
  },
  {
    path: '/height',
    private: false,
    title: dummy_t('userSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <DietSettingsHeight />,
  },
  {
    path: '/summary',
    private: false,
    title: dummy_t('userSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <DietSettingsAllSummary />,
  },
];

export default descendantRoutes;
